<template>
  <div>
    <div class="comm_popup_wrap_small">
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :columnsautoresize="true"
        :dataset="'ds_building'"
        width="100%"
      />
    </div>
    <div class="comm_btnBot_wrap mrR30 mrL30">
      <div class="btn_wrapR">
        <sui-button
          type="button"
          class="comm_btn_border"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMY_00008_P01', // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: null,
    },
    data: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_BUIL_NM'),
        datafield: 'locationName',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'ds_building',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'arrayalOrder', type: 'string', map: 'arrayalOrder' },
      { name: 'value', type: 'string', map: 'value' },
      { name: 'text', type: 'string', map: 'text' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'parentsId', type: 'string', map: 'parentsId' },
      { name: 'originalFinalModificationDTM', type: 'string', map: 'originalFinalModificationDTM' },
      { name: 'locationUseYn', type: 'string', map: 'locationUseYn' },
      { name: 'locationTypeCode', type: 'string', map: 'locationTypeCode' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'finalModificationProgramId', type: 'string', map: 'finalModificationProgramId' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationProgramId', type: 'string', map: 'firstRegistrationProgramId' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'businessSectorDivisionCode', type: 'string', map: 'businessSectorDivisionCode' },
      { name: 'floorId', type: 'string', map: 'floorId' },
      { name: 'folderYn', type: 'string', map: 'folderYn' },
      { name: 'headquarterLocationId', type: 'string', map: 'headquarterLocationId' },
      { name: 'id', type: 'string', map: 'id' },
      { name: 'jobDistrictId', type: 'string', map: 'jobDistrictId' },
      { name: 'level', type: 'string', map: 'level' },
      { name: 'locationEnglishName', type: 'string', map: 'locationEnglishName' },
      { name: 'locationId', type: 'string', map: 'locationId' },
      { name: 'locationName', type: 'string', map: 'locationName' },
      { name: 'locationNoteContent', type: 'string', map: 'locationNoteContent' }],
  }],
  mounted() {
    this.ds_building.$on(this.ds_building.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
    this.ds_building.setRawData(this.data);
  },
  destroyed() {
    this.ds_building.$off(this.ds_building.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    datasetSelectionChanged(data) {
      this.$emit('onSetFocus', this.ds_building.data[data.newSelections].id);
    },
  },
};
</script>
<style scoped>
</style>
